import styled, { css } from 'styled-components';

export const Container = styled.div`
  background: #FFF;
  height: 40px;
  border-radius: 0.25rem;
  padding: 12px;
  width: 100%;
  border: 1px solid var(--gray-100);
  margin-bottom: 1.2rem ;
  position: relative;
  display: flex;
  align-items: center;

  ${props => (props.isErroded && !props.isFilled) && css`
    border-color: #ff073a;
  `}

  ${props => props.isFocused && css`
    transition: .4s;
    border-color: #66afe9;
    outline: 0;
    box-shadow: 0px 1px 8px #66afe9;
  `}

  ${props => (props.isErroded && props.isFocused) && css`
  border-color: #ff073a;
  box-shadow: 0px 1px 8px #dc3545;
  `}

  ${props => (props.isFilled && props.isFocused) && css`
    color: var(--color-primary);
    border-color: #66afe9;
    outline: 0;
    box-shadow: 0px 1px 8px #66afe9;
  `}
  input {
    flex: 1;
    background: transparent;
    border: 0;
    color: var(--color-500);
    font-size: 18px;
    &&::placeholder {
      color: #333333;
    }
  }
  svg {
    color: #333333;
    cursor: pointer;
  }

  .eye-container {
    position: absolute;
    outline: 0;
    border: 0;
    padding: 0 12px;
    border-radius: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: var(--gray-100);
    display: flex;
    align-items: center;
  }
`;

export const Error = styled.div`
  height: 20px;
  display: flex;
  align-items: center;
  svg {
    padding: 0;
    padding-left: 12px;
    margin: 0;
    cursor: auto;
  }

  span {
    color: #ff073a;
    font-size: 0.8rem;
    position: absolute;
    top: 40px;
    left: 0;
  }
`;
